import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom'; // Импортируем useNavigate

import { getHistory, getSession } from '../services/Api'; // Импортируем функции

import 'react-loading-skeleton/dist/skeleton.css';

import defaultAvatar from '../assets/img/default-avatar.jpg';

import './History.css';

const History = () => {
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [activeProfileIndex, setActiveProfileIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const historyData = await getHistory();
        const formattedProfiles = historyData.map(analysis => ({
          id: analysis.id,
          name: `${analysis.firstName || 'Неизвестно'} ${analysis.lastName || ''}`.trim(),
          date: new Date(analysis.time * 1000).toLocaleDateString(),
          imgSrc: analysis.photoUrl || defaultAvatar
        }));

        setProfiles(formattedProfiles);
      } catch (error) {
        console.error('Ошибка при загрузке данных:', error);
        setError('Ошибка при загрузке данных');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleToggleContent = index => {
    setActiveProfileIndex(activeProfileIndex === index ? null : index);
  };

  // В файле History.jsx
  const handleNavigateToResult = async profileId => {
    try {
      const sessionData = await getSession(profileId);
      navigate('/result', { state: { profileData: sessionData.data } });
    } catch (error) {
      console.error('Ошибка при получении сессии анализа:', error);
    }
  };

  if (loading) {
    return (
      <div className="profile-history">
        <h2 className="profile-history__title">
          <Skeleton width={150} height={25} />
        </h2>
        <div className="profile-history__list">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="profile-history__item">
              <div className="profile-history__header">
                <Skeleton circle width={50} height={50} />
                <div className="block-name">
                  <Skeleton width={150} />
                  <Skeleton width={100} />
                </div>
              </div>
              <div className="profile-history__content">
                <Skeleton width={150} height={30} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (profiles.length === 0) {
    return <div>Нет данных для отображения</div>;
  }

  return (
    <div className="profile-history">
      <h2 className="profile-history__title">
        <img src="/assets/icons/svit.svg" alt="" />
        История профилей
      </h2>
      <div className="profile-history__list">
        {profiles.map((profile, index) => (
          <div key={profile.id} className="profile-history__item" onClick={() => handleToggleContent(index)}>
            <div className="profile-history__header">
              <img src={profile.imgSrc} className="image-prof" alt="" />
              <div className="block-name">
                <span className="profile-history__name">{profile.name}</span>
                <span className="profile-history__date">{profile.date}</span>
              </div>
              <span className={`profile-history__arrow ${activeProfileIndex === index ? 'active' : ''}`}>
                <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.0572949 8.78536L1.94263 10.6667L8.99996 3.6147L16.0573 10.6667L17.9426 8.78002L10.8853 1.73337C10.3852 1.23345 9.70707 0.952606 8.99996 0.952606C8.29286 0.952606 7.6147 1.23345 7.11463 1.73337L0.0572949 8.78536Z"
                    fill="white"
                  />
                </svg>
              </span>
            </div>
            <div
              className="profile-history__content"
              style={{
                display: activeProfileIndex === index ? 'block' : 'none'
              }}
            >
              <button className="profile-history__button" onClick={() => handleNavigateToResult(profile.id)}>
                Перейти к результату
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default History;
